import { render, staticRenderFns } from "./CategoriesList.vue?vue&type=template&id=1a9af338&scoped=true&"
import script from "./CategoriesList.vue?vue&type=script&lang=js&"
export * from "./CategoriesList.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesList.vue?vue&type=style&index=0&id=1a9af338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9af338",
  null
  
)

export default component.exports